export const DraftBadge = ({ isActive }: { isActive: boolean }) => (
  <span
    className={
      // "bg-secondary-hover" is what is in the design spec, but that's the
      // current "active" sidebar color and updating that is out of scope so
      // this is a "close enough to the design spec" solution for now.
      (isActive ? 'bg-gray-100 ' : 'bg-secondary-hover ') +
      'text-sm ' +
      'ml-auto px-2 py-0.5 rounded-md'
    }
    data-testid="draft-badge"
  >
    Draft
  </span>
);
